require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-nigeria-covid-19-action-recovery-and-economic-stimulus.json") })
        }
      }, "path---en-us-project-nigeria-covid-19-action-recovery-and-economic-stimulus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-nigeria-covid-19-action-recovery-and-economic-stimulus!./.cache/json/en-us-project-nigeria-covid-19-action-recovery-and-economic-stimulus.json
// module id = 549
// module chunks = 231608221292675